import React, { useEffect, useRef } from 'react';
import { usePrebid } from '../hooks/usePrebid';

export interface AdUnitProps {
  code: string;
  sizes: number[][];
  bids: Array<{
    bidder: string;
    params: Record<string, any>;
  }>;
}

export const AdUnit: React.FC<AdUnitProps> = ({ code, sizes, bids }) => {
  const divRef = useRef<HTMLDivElement>(null);
  const { pbjs } = usePrebid();

  useEffect(() => {
    if (!divRef.current || !pbjs) return;

    const adUnit = {
      code,
      mediaTypes: {
        banner: {
          sizes,
        },
      },
      bids,
    };

    pbjs.addAdUnits([adUnit]);
    pbjs.requestBids({
      adUnitCodes: [code],
      bidsBackHandler: () => {
        window.googletag.cmd.push(() => {
          window.googletag.display(code);
        });
      },
    });

    return () => {
      pbjs.removeAdUnit(code);
    };
  }, [code, sizes, bids, pbjs]);

  return <div id={code} ref={divRef} />;
}; 
